"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UberUtils = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _globals = _interopRequireDefault(require("./globals"));

// Utils that are above the component layer
var UberUtils =
/*#__PURE__*/
function () {
  function UberUtils() {
    (0, _classCallCheck2.default)(this, UberUtils);
    // For mocking
    this._globals = _globals.default;
  }

  (0, _createClass2.default)(UberUtils, [{
    key: "displayError",
    value: function displayError(text) {
      this._globals.displayAlert({
        title: 'Unexpected Error',
        text: text
      });
    }
  }, {
    key: "setFormErrorsFromAPIError",
    value: function setFormErrorsFromAPIError(err, form) {
      try {
        var message = JSON.parse(err.graphQLErrors[0].message);
        message.error.forEach(function (err) {
          form.getField(err.field).setErr(err.error);
        });
      } catch (_err) {
        // An error can occur if the message is not a JSON object, e.g. if we don't have access to
        // archive, etc... The caller will still throw the main error. TODO: Is there a better way to
        // handle this? Should all messages be JSON objects? That would probably be too limiting,
        // right?
        this.displayError(err.toString());
      }
    }
  }, {
    key: "tryAndSetFormErrorsIfAPIError",
    value: function () {
      var _tryAndSetFormErrorsIfAPIError = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(promiseFactory, form) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return promiseFactory();

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                this.setFormErrorsFromAPIError(_context.t0, form); // We throw the error so that the entire listener chain is aborted

                throw _context.t0;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function tryAndSetFormErrorsIfAPIError(_x, _x2) {
        return _tryAndSetFormErrorsIfAPIError.apply(this, arguments);
      }

      return tryAndSetFormErrorsIfAPIError;
    }()
  }, {
    key: "tryAndDisplayErrorIfAPIError",
    value: function () {
      var _tryAndDisplayErrorIfAPIError = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(promiseFactory) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return promiseFactory();

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                this.displayError(_context2.t0.toString()); // We throw the error so that the entire listener chain is aborted

                throw _context2.t0;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function tryAndDisplayErrorIfAPIError(_x3) {
        return _tryAndDisplayErrorIfAPIError.apply(this, arguments);
      }

      return tryAndDisplayErrorIfAPIError;
    }()
  }]);
  return UberUtils;
}();

exports.UberUtils = UberUtils;

var _default = new UberUtils();

exports.default = _default;